import { useMemo } from "react";
import { useIdeasUrlState } from "./useIdeasUrlState";
import {EvidenceInclusion} from "../components/ideas/store/types";

// Helper to convert evidenceInclusion to assigned/suggested booleans
export const evidenceInclusionToState = (evidenceInclusion: EvidenceInclusion) => {
  switch (evidenceInclusion) {
  case 'assigned':
    return { assigned: true, suggested: false };
  case 'suggested':
    return { assigned: false, suggested: true };
  case 'total':
  default:
    return { assigned: true, suggested: true };
  }
};

// Helper to convert assigned/suggested booleans to evidenceInclusion
export const stateToEvidenceInclusion = (assigned: boolean, suggested: boolean): EvidenceInclusion => {
  if (assigned && suggested) return 'total';
  if (assigned && !suggested) return 'assigned';
  if (!assigned && suggested) return 'suggested';
  return 'total';
};

export const useEvidenceInclusion = () => {
  const { evidenceInclusion, setEvidenceInclusion } = useIdeasUrlState({});
  const state = useMemo(() => evidenceInclusionToState(evidenceInclusion), [evidenceInclusion]);

  const setAssigned = (checked: boolean) => {
    const currentSuggested = state.suggested;
    if (!checked && !currentSuggested) {
      return;
    }
    const newEvidenceInclusion = stateToEvidenceInclusion(checked, currentSuggested);
    setEvidenceInclusion(newEvidenceInclusion);
  };

  const setSuggested = (checked: boolean) => {
    const currentAssigned = state.assigned;
    if (!checked && !currentAssigned) {
      return;
    }
    const newEvidenceInclusion = stateToEvidenceInclusion(currentAssigned, checked);
    setEvidenceInclusion(newEvidenceInclusion);
  };

  return {
    assigned: state.assigned,
    suggested: state.suggested,
    setAssigned,
    setSuggested,
    evidenceInclusion
  };
}; 